// extracted by mini-css-extract-plugin
export default {"_":"HamburgerIcon____U7ueB","open":"HamburgerIcon_open__iaJG+"};